// test1672
(1672 && 0);
